import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "context/AuthContext";

const DomainContext = createContext();

export const DomainProvider = ({ children }) => {
  const [domainId, setDomainId] = useState(() => localStorage.getItem("domainId"));
  const [source, setSource] = useState(() => localStorage.getItem("source"));
  const { currentDomain } = useAuth();

  useEffect(() => {
    if (currentDomain && currentDomain.source) {
      setSource(currentDomain.source);
      localStorage.setItem("source", currentDomain.source);
    }
  }, [currentDomain]);

  useEffect(() => {
    if (domainId) {
      localStorage.setItem("domainId", domainId);
    }
    if (source) {
      localStorage.setItem("source", source);
    }
  }, [domainId, source]);

  return (
    <DomainContext.Provider value={{ domainId, setDomainId, source, setSource }}>
      {children}
    </DomainContext.Provider>
  );
};

export const useDomain = () => useContext(DomainContext);